import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Bali_Xperiences_Logo.png")